module.exports = __webpack_public_path__ + "school/img/zhiguolizheng.bccd5245.png";